<template>
<v-container fluid>
    <v-row>
        <v-col>
            <h4 class="text-h4">Debit Notes</h4>
            <p class="text-subtitle-1">List of suppliers debit notes</p>
            <v-divider></v-divider>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="3" v-if="hasPermission(perm.debit_note.create)">
            <v-btn class="primary" block @click="handleNew">
                <v-icon left>mdi-plus</v-icon>
                new debit note
            </v-btn>
        </v-col>
        <v-col cols="3">
            <v-menu offset-y :close-on-content-click="false" min-width="300">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        block
                        v-bind="attrs"
                        v-on="on"
                        depressed
                        >
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </template>
                <v-card 
                    flat
                    >
                    <v-card-title>Search</v-card-title>
                    <v-card-text>
                        <DebitNoteListSearch ref="form"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" depressed block @click="$refs.form.submit()">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <DebitNoteList/>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import permissions from './../../data/permissions';
import DebitNoteListSearch from "./../../components/purchase/DebitNoteListSearch"
import DebitNoteList from "./../../components/purchase/DebitNoteList.vue"
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "DebitNoteListView",
    components: {
        DebitNoteList,
        DebitNoteListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            search: "purchase/debitNote/search"
        }),
        handleNew() {
            this.$router.push({ name: "DebitNoteCreate"})
        },
        handleRefresh() {
            this.search();
        }
    }
}
</script>

<style>
</style>